import React from 'react'
import { SessionProvider } from '@crunchyroll/cr-static-shared-components'

const wrapRoot = ({ element }) => <SessionProvider>{element}</SessionProvider>
export default wrapRoot